import React from 'react';
import cn from 'classnames';

import { publishAgeBadge } from './catalogBadges';
import './CatalogIntegrationSelector.scss';

const CatalogIntegrationSelector = ({ integrations, selectedId, onSelect }) => (
  <div className='catalogs-integration-selector'>
    <div className='catalogs-integration-list'>
      {integrations.map(integration => {
        const isSelected = Number(integration.id) === Number(selectedId);
        const showSelection = isSelected && integrations.length > 1;
        return (
          <button
            aria-pressed={isSelected}
            className={cn('catalogs-integration-row', { selected: showSelection })}
            key={integration.id}
            type='button'
            onClick={() => onSelect(Number(integration.id))}
          >
            <span className='catalogs-integration-copy'>
              <span aria-hidden='true' className={cn('catalogs-integration-selection-indicator', { active: showSelection })} />
              <span className='catalogs-integration-domain'>{integrationDomain(integration)}</span>
              <span aria-hidden='true' className='catalogs-integration-separator'>·</span>
              <span className='catalogs-integration-details'>{integrationDetails(integration)}</span>
            </span>
            <PublishedStatus publishedAt={integration.live?.publishedAt} />
          </button>
        );
      })}
    </div>
  </div>
);

const PublishedStatus = ({ publishedAt }) => {
  const publishAge = publishAgeBadge(publishedAt);
  return publishAge
    ? <span className={`catalogs-status-badge ${publishAge.tone}`}>{`Published ${publishAge.ageLabel}`}</span>
    : <span className='catalogs-status-badge'>Not published</span>;
};

const integrationDomain = integration => integration?.domain || integration?.shopName || `Integration ${integration?.id}`;

const integrationDetails = integration => {
  const shopName = String(integration?.shopName || '').trim();
  const shopifyDomain = shopName ? (shopName.endsWith('.myshopify.com') ? shopName : `${shopName}.myshopify.com`) : null;
  return [shopifyDomain, `ID ${integration.id}`].filter(Boolean).join(', ');
};

export default CatalogIntegrationSelector;
